import dynamic from 'next/dynamic';
import { type FC } from 'react';

import { getPublicStaticEnvironment } from '@/src/environment';
import { useIsIdle } from '@/src/hooks/use-is-idle';

const ClientIdleUserDialog = dynamic(
  () => import('./ClientIdleUserDialog').then(mod => mod.ClientIdleUserDialog),
  { ssr: false },
);

const environment = getPublicStaticEnvironment();

export const IdleUserDialog: FC = () => {
  /**
   * Mounting the watcher pulls in the dynamically imported client dialog and starts the inactivity
   * tracking, neither of which is needed for the initial render. It is deferred until the browser
   * is idle to keep that work off the critical load path.
   */
  const isBrowserIdle = useIsIdle();
  if (
    isBrowserIdle &&
    process.env.NODE_ENV !== 'test' &&
    environment.idleUserWatcherEnabled !== false
  ) {
    return <ClientIdleUserDialog />;
  }
  return null;
};
